import { useState, useEffect,useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import folder from "../../folder.svg"; // Import the folder image
import "../../styles/AdminHome.css"; // Import the CSS file for styling
import axios from 'axios';
import BASE_URL from '../../BaseUrl';
import { GlobalContext } from '../GlobalContext';

export default function AssistantHome({active,setActive, setMobileActive}) {
    const {admin, setAdmin} = useContext(GlobalContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [reload, setReload] = useState(false);
    const [message, setMessage] = useState("error message");
    const [showMessage, setShowMessage] = useState(false);

    const [showAddNewCourseForm, setShowAddNewCourseForm] = useState(false);
    const [newCourse, setNewCourse] = useState({
        courseId:"",
        name:"",
        term:"",
        year:"",
        category:""
    });
    const [courseToEdit, setCourseToEdit] = useState({
                                            name:"",
                                            courseId:"",
                                            term:"",
                                            year:"",
                                            category:""
                                        });
    const [showEditCourseForm, setShowEditCourseForm] = useState(false);
    const category = ["عربي","انجليزي","رياضيات","فيزياء","كيمياء","أحياء","تاريخ","جغرافيا","فلسفة","علم نفس","دين","فرنساوي","الماني","ايطالي","اسباني","جيولوجيا","علوم","دراسات"];
    const termsArabic = ["الفصل الدراسي الاول", "الفصل الدراسي الثاني"];
    const yearsArabic = ["الصف الاول الابتدائي","الصف الثاني الابتدائي","الصف الثالث الابتدائي","الصف الرابع الابتدائي","الصف الخامس الابتدائي","الصف السادس الابتدائي","الصف الاول الاعدادي","الصف الثاني الاعدادي","الصف الثالث الاعدادي","الصف الاول الثانوي","الصف الثاني الثانوي","الصف الثالث الثانوي"];


                                        const arabicNumbers = {
        الاول: "١",
        الثاني: "٢",
        الثالث: "٣",
        الرابع: "٤",
        الخامس: "٥",
        السادس: "٦"
    };

    const shortTerm = (term)=>{
        return 'ت'+arabicNumbers[term.split(" ")[2]];
    }
    const levelMap = {
        الابتدائي: "ب",
        الاعدادي: "ع",
        الثانوي: "ث"
    };

    const shortYears =(year) => {
        const parts = year.split(" ");
        const numberWord = parts[1];       
        const levelWord = parts[2];        

        return arabicNumbers[numberWord] + levelMap[levelWord];
    };

    const changeStyle = (id)=>{
            const el = document.getElementById(id);
            el.style.borderColor = "black";
            el.style.color = "black";
    }

    const sendNewCourse = ()=>{
        if(newCourse.year === ""){
            const el = document.getElementById("year");
            el.style.borderColor = "red";
            el.style.color = "red";
            return;
        }
        if(newCourse.term === ""){
            const el = document.getElementById("term");
            el.style.borderColor = "red";
            el.style.color = "red";
            return;
        }
        if(newCourse.category === ""){
            const el = document.getElementById("category");
            el.style.borderColor = "red";
            el.style.color = "red";
            return;
        }
        if(newCourse.name === ""){
            const el = document.getElementById("course-name");
            el.style.borderColor = "red";
            el.style.color = "red";
            return;
        }

        axios.post(`${BASE_URL}/assistant/new-course`,newCourse,{withCredentials: true})
        .then((response)=>{
            setMessage(response.data);
            setShowMessage(true);
            setShowAddNewCourseForm(false);
            setNewCourse({
                    courseId:"",
                    name:"",
                    term:"",
                    year:"",
                    category:""
                })
            setReload(!reload);
        }).catch((error)=>{
            console.log(error);
        })
    }


    const updateCourse = ()=>{
        if(courseToEdit === null || courseToEdit === undefined){
            return;
        }
        axios.put(`${BASE_URL}/assistant/update-course`,courseToEdit,{withCredentials:true})
        .then((response)=>{
            setMessage(response.data);
            setShowMessage(true);
            setShowEditCourseForm(false);
            setReload(!reload);
        }).catch((error)=>{
            console.log(error);
        })
    }

   useEffect( () => {  async function fetchData() {
    var isNull = false;
    if(admin === null || admin === undefined){
        await axios.get(`${BASE_URL}/assistant/get-assistant-by-token`,{withCredentials:true})
        .then((response)=>{
            setAdmin(response.data);
        }).catch((error)=>{
            navigate("/")
            isNull = true;
        })
    }
    
    if(isNull) return;
    await axios.get(`${BASE_URL}/assistant/courses`, { withCredentials: true })
        .then((response) => {
            const updateAdmin = { ...admin, courses: response.data };
            setAdmin(updateAdmin);
            setLoaded(true);
            
        }).catch((error) => {
            console.error("Error fetching course data:", error);
            navigate("/");
            // Handle error appropriately, e.g., show a notification or redirect
        })
    await axios.get(`${BASE_URL}/assistant/teacher-info`, { withCredentials: true }).
    then(async (response)=>{
        const updatedAdmin = {...admin, teacherName: response.data[1], teacherId: response.data[0]};
        await setAdmin(updatedAdmin);
    }).catch((err)=>{
        console.log(err);
    })
   }
   fetchData();
   setActive("المواد الدراسية");
   setMobileActive("courses mobile");
},[reload]);
    
    return(
        <div>
                   
            {loaded &&(    
                <div className='admin-home-container'>
                    
                    <div style={{paddingBottom:"50px"}}><h3>المواد الدراسية </h3>
                    <button className='add-new-course' onClick={()=>setShowAddNewCourseForm(true)}>اضافةمادة</button>
                    {admin.courses.map((course)=>(
                    <div className={`course-card-animation ${active==="المواد الدراسية" ? "course-card-in" : "course-card-out"}`}>
                        <div className='course-card' onClick={() => {navigate(`/assistant-home/folder/${course.courseId}`);}}>
                            
                                <div className='folder-card-button'>
                                    <button className='assistant-edit-course' onClick={(e)=>{
                                    e.stopPropagation();
                                    setCourseToEdit(course);
                                    setShowEditCourseForm(true);
                                }}>تعديل</button>
                                </div>
                                
                            <div style={{width:"35%",display:"block", textAlign:"right",lineBreak:"auto", paddingTop:"15px"}}>
                                <h4 style={{width:"100%", textAlign:"right",lineBreak:"auto", height:"80%" , marginBottom:"0%"}}>{course.name}</h4>
                                <div style={{display:"flex", justifyContent:"right"}}>
                                    <p style={{height:"20%", fontSize:"smaller", marginBottom:"0%", fontWeight:"bold"}}>{shortTerm(course.term)}</p>
                                    <p style={{height:"20%", fontSize:"smaller", marginBottom:"0%", fontWeight:"bold"}}>{shortYears(course.year)}</p>
                                </div>      
                                </div>         
                            <img src={folder} alt='no' className='course-photo'></img>
                            
                        </div>
                    </div>
                    ))}
                    </div>
            </div>)}

            {showEditCourseForm&&(
                <div className="overlay">
                <div className='add-new-course-form'>
                    <h2>تعديل المادة</h2>
                    <label>اسم المادة</label>
                    <input id='course-name' 
                        dir="rtl"
                        lang="ar" 
                        type="text" 
                        value={courseToEdit.name} 
                        onChange={(e)=>{setCourseToEdit({...courseToEdit, name:e.target.value});
                    changeStyle(e.target.id);
                }} />
                    <div className='year-term-selection'>
                    <select value={courseToEdit.year} id="year" onChange={(e)=>{setCourseToEdit({...courseToEdit, year:e.target.value});
                    changeStyle(e.target.id);
                }}>
                        <option value={""}>--- الصف ---</option>
                        {yearsArabic.map((year,index)=>(
                            <option value={yearsArabic[index]} >{year}</option>
                        ))}
                    </select>
                    <select value={courseToEdit.term} id="term" onChange={(e)=>{setCourseToEdit({...courseToEdit, term:e.target.value});
                    changeStyle(e.target.id);
                }}>
                        <option value={""}>---الفصل الدراسي---</option>
                        {termsArabic.map((term,index)=>(
                            <option value={termsArabic[index]}>{term}</option>
                        ))}
                    </select>
                    <select
                        id="category"
                        value={courseToEdit.category}
                        onChange={(e) => {setCourseToEdit({...courseToEdit, category:e.target.value});
                        changeStyle(e.target.id);
                    }}
                    >
                        <option value="">--التصنيف--</option>
                        {category.map((subj, index) => (
                        <option value={category[index]}>
                            {subj}
                        </option>
                        ))}
                    </select>
                    </div>
                    <div className='new-course-form-buttons'>
                        <button onClick={()=>{
                            setCourseToEdit({
                                            name:"",
                                            courseId:"",
                                            term:"",
                                            year:"",
                                            category:""
                                        });
                                        setShowEditCourseForm(false);
                        }}>إلغاء</button>
                        <button onClick={updateCourse} >تعديل</button>
                    </div>
                </div>
                </div>
            )}

            {showAddNewCourseForm&&(
                <div className="overlay">
                <div className='add-new-course-form'>
                    <h2>مادة جديدة</h2>
                    <label>اسم المادة</label>
                    <input id='course-name' 
                        dir="rtl"
                        lang="ar"
                        type="text" 
                        value={newCourse.name} 
                        onChange={(e)=>{setNewCourse({...newCourse, name:e.target.value});
                    changeStyle(e.target.id);
                }} />
                    <div className='year-term-selection'>
                    <select id="year"
                    disabled={newCourse.category === "تأسيسي" || newCourse.category === "أخرى"}
                    onChange={(e)=>{
                        // setNewCourse({...newCourse, year:e.target.value});
                        console.log(e.target.value);
                        changeStyle(e.target.id);
                        var num = 0;
                        if(e.target.value !== "" && newCourse.term !== ""){
                            num = ((yearsArabic.indexOf(e.target.value) + 1) * 2) - 1;
                            num += termsArabic.indexOf(newCourse.term);
                            setNewCourse({...newCourse, number: num ,year:e.target.value});
                        } 
                        if(e.target.value === "الصف الثالث الثانوي"){
                            console.log("in 2 th");
                            num = 23;
                            setNewCourse({...newCourse, number: num ,year:e.target.value, term:e.target.value});
                            console.log("term is modified");
                            document.getElementById("term").value = "";
                            document.getElementById("term").style = {color:"gray"};
                        }else{
                            setNewCourse({...newCourse, number: num ,year:e.target.value});
                        }
                }}>
                        <option value={""}>--- الصف ---</option>
                        {yearsArabic.map((year,index)=>(
                            <option value={yearsArabic[index]} >{year}</option>
                        ))}
                    </select>
                    <select id="term" 
                        disabled={newCourse.category === "تأسيسي" || newCourse.category === "أخرى" || newCourse.year === "الصف الثالث الثانوي"}
                        onChange={(e)=>{
                        // setNewCourse({...newCourse, term:e.target.value});
                        changeStyle(e.target.id);
                        var num = 0;
                        if(e.target.value !== "" && newCourse.year !== ""){
                            num = ((yearsArabic.indexOf(newCourse.year) + 1) * 2) - 1;
                            num += termsArabic.indexOf(e.target.value);
                        }
                        setNewCourse({...newCourse, number: num, term:e.target.value});
                }}>
                        <option value={""}>---الفصل الدراسي---</option>
                        {termsArabic.map((term,index)=>(
                            <option value={termsArabic[index]}>{term}</option>
                        ))}
                    </select>
                    <select
                        id="category"
                        onChange={(e) => {
                        changeStyle(e.target.id);
                        if(e.target.value === "تأسيسي" || e.target.value === "أخرى"){
                            var yearEl = document.getElementById("year");
                            var termEl = document.getElementById("term");
                            yearEl.value = "";
                            termEl.value = "";
                            yearEl.style = {};
                            termEl.style = {};
                            setNewCourse({...newCourse, year:e.target.value, term:e.target.value, number: 0, category:e.target.value});
                            
                        }else{
                            setNewCourse({...newCourse, category:e.target.value});
                        }
                        
                    }}
                    >
                        <option value="">--التصنيف--</option>
                        {category.map((subj, index) => (
                        <option value={category[index]}>
                            {subj}
                        </option>
                        ))}
                    </select>
                    </div>
                    <div className='new-course-form-buttons'>
                        <button onClick={()=>{
                            setNewCourse({
                                            name:"",
                                            courseId:"",
                                            term:"",
                                            year:"",
                                            category:""
                                        });
                                        setShowAddNewCourseForm(false);
                        }}>إلغاء</button>
                        <button onClick={sendNewCourse}>اضافة المادة</button>
                    </div>
                </div>
                </div>
            )}
            { showMessage && (
                <div className="overlay">
                <div className="home-owner-message">
                    <p>{message}</p>
                    <button onClick={() => setShowMessage(false)}>اغلاق</button>
                </div>
                </div>
            )}
        </div>

        
        
    )

    

}